import { hasShortcutsAccess } from "@faire/help-center-utils/serialized-data/shortcutsAccess";
import { getSettingSelfServeRetailerTaxonomy } from "@faire/help-center-utils/settings/getSettingSelfServeRetailerTaxonomy";
import { Grid } from "@faire/web/slate/Layout";
import { useResponsiveValue } from "@faire/web/ui/hooks/useResponsiveValue";
import React, { useMemo } from "react";
import { useIsSelfServeHomePage } from "../hooks/useIsSelfServeHomePage";
import { useSelfServeContext } from "../hooks/useSelfServeContext";
import { NodeChildrenRenderer } from "./NodeChildrenRenderer";
export var IssueTopics = function IssueTopics(_ref) {
  var parentNode = _ref.parentNode,
    selectedNode = _ref.selectedNode,
    setSelectedNode = _ref.setSelectedNode,
    isAutofocusOnMobile = _ref.isAutofocusOnMobile,
    bottomElementRef = _ref.bottomElementRef,
    loadTimingRef = _ref.loadTimingRef;
  var itemsPerRowHome = useResponsiveValue({
    mobileAndAbove: 2,
    tabletAndAbove: 3,
    desktopAndAbove: 4,
    xLargeAndAbove: 5
  });
  var itemsPerRowHomeWithShortcuts = useResponsiveValue({
    mobileAndAbove: 2,
    desktopAndAbove: getSettingSelfServeRetailerTaxonomy() ? 2 : 3
  });
  var itemsPerRowOthers = useResponsiveValue({
    mobileAndAbove: 1,
    tabletAndAbove: 2
  });
  var _useSelfServeContext = useSelfServeContext(),
    context = _useSelfServeContext.context;
  var isSelfServeHomePage = useIsSelfServeHomePage();
  var isFairePrograms = (parentNode === null || parentNode === void 0 ? void 0 : parentNode.id) === "FairePrograms";
  var displayInTwoColumns = isFairePrograms || isSelfServeHomePage;
  var columns = useMemo(function () {
    var column;
    if (displayInTwoColumns) {
      column = hasShortcutsAccess() ? itemsPerRowHomeWithShortcuts : itemsPerRowHome;
    } else {
      column = itemsPerRowOthers;
    }
    return column;
  }, [displayInTwoColumns, itemsPerRowHome, itemsPerRowHomeWithShortcuts, itemsPerRowOthers]);
  return /*#__PURE__*/React.createElement(Grid, {
    ref: loadTimingRef,
    gap: "2x",
    columns: columns,
    style: {
      width: "100%",
      gridAutoRows: displayInTwoColumns ? "minmax(100px, auto)" : "minmax(55px, auto)"
    }
  }, /*#__PURE__*/React.createElement(NodeChildrenRenderer, {
    context: context,
    node: parentNode,
    selectedNode: selectedNode,
    onClickOnNode: setSelectedNode,
    isAutofocusOnMobile: isAutofocusOnMobile,
    bottomElementRef: bottomElementRef
  }));
};